import type { ApplicationType } from '@application/types';

export interface MtApplicationsBreederPageControllerData {
  type: ApplicationType;
}

export interface MtApplicationsBreederPageControllerProps
  extends MtApplicationsBreederPageControllerData {}
